module.exports = __webpack_public_path__ + "static/media/img-action-message@3x.8f8e8bfa.png";